import React, { useState } from "react";
import { toast } from "react-toastify";
import Popup from "./Popup";
import {
  DATE_TIME_FORMAT,
  fileNameType,
  quotationStatusColor,
  quotationStatusLabel,
} from "app/constants";
import moment from "moment";
import { commonServices } from "app/services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import messages from "../../../../services/api/messages";

function QuotationCell(props) {
  const { width, quotationStatus, quotationInfo, caseInfo } = props;
  const [anchor, setAnchor] = useState(null);

  const handleLeftClickQuotation = () => {
    const caseId = caseInfo?.caseId || "";
    const fileType = fileNameType["quotation"];
    const customerName = caseInfo?.customer?.companyNameKanji || "";
    const timeStamp = moment().format("YYYYMMDDHHmmss");

    if (quotationInfo.generatedExcel) {
      commonServices
        .downloadPDFWithFileId(
          quotationInfo.generatedExcel,
          `${fileType}_${caseId}_${customerName}_${timeStamp}`
        )
        .catch(() => {
          toast.error(messages.downloadFail);
        });
    }
  };

  const handleRightClickQuotation = (e) => {
    e.preventDefault();
    setAnchor(e.target);
  };

  return (
    <>
      <div
        className="h-full border border-[#B3B3B3] px-2 py-4 shrink-0"
        style={{
          width: width,
        }}
      >
        <p className="text-sm leading-[18px] tracking-[.2em] truncate text-center">
          <button
            style={{
              color: quotationStatusColor[quotationStatus],
              cursor: "pointer",
            }}
            onClick={handleLeftClickQuotation}
            onContextMenu={handleRightClickQuotation}
          >
            {quotationStatusLabel[quotationStatus]}
          </button>
        </p>
      </div>

      <Popup
        id={`quotation-${quotationInfo._id}`}
        anchor={anchor}
        open={Boolean(anchor)}
      >
        <div className="flex flex-col">
          <button
            className="bg-[#c7c2c2] w-7 h-7 rounded-full ml-auto flex items-center justify-center"
            onClick={() => setAnchor(null)}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <p className="flex gap-2">
            最終更新日:{" "}
            {moment(quotationInfo?.fileInfo?.updatedAt).format(
              DATE_TIME_FORMAT
            )}
          </p>
        </div>
      </Popup>
    </>
  );
}

export default QuotationCell;
